import React, { useState } from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import styled from 'styled-components'

import MenuItem from '../MenuItem'
import { MysqlCategories } from '../../../graphqlTypes'

const Item = styled.li`
  border-right: 1px solid #eee;
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  margin: 0 0 8px;
  padding: 0 8px;
  &:last-child {
    border: 0;
  }
  a {
    color: #444;
    text-decoration: none;
  }
`

const CategoryIcon = styled.img`
  margin-right: 5px;
  width: 32px;
  height: 32px;
  object-fit: contain;
  vertical-align: middle;
`

const CategoryTitle = styled.span`
  vertical-align: middle;
`

const Menu = styled.ul`
  background: ${({ theme }) => theme.palette.background.main};
  border: 1px solid ${({ theme }) => theme.palette.border.main};
  border-radius: 3px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  list-style: none;
  margin: 1px 0 0;
  padding: 15px 20px;
  position: absolute;
`

export default function CategoryItem({ category }: { category: MysqlCategories }) {
  const [openMenu, setOpenMenu] = useState(false)

  if (!category.categories || !category.categories.length) return null

  const categories = category.categories as MysqlCategories[]

  return (
    <Item onMouseEnter={() => setOpenMenu(true)} onMouseLeave={() => setOpenMenu(false)}>
      <LazyLoadComponent>
        <CategoryIcon
          alt={`${category.title}部門 受賞商品`}
          src={`${category.categories[0]!.fields!.imageUrl}?auto=format&w=32&h=32`}
        />
      </LazyLoadComponent>
      <CategoryTitle>{category.title}</CategoryTitle>
      {openMenu && (
        <Menu>
          {categories.map((category) => (
            <MenuItem category={category} key={category.id} />
          ))}
        </Menu>
      )}
    </Item>
  )
}
